module.exports = __webpack_public_path__ + "static/media/logo_animated_lg.96acc2ad.gif";